export default __webpack_public_path__ + "static/media/ProductBlack.2f353fa5.svg";